import { useEffect } from "react";

const useNavHighlight = (elementId) => {
    useEffect(() => {
        const links = document.querySelectorAll(".headerLinks");
        const element = document.getElementById(elementId);

        links.forEach(el => el.classList.remove("activeHeaderLink"));
        element?.classList.add("activeHeaderLink");
    }, [elementId]);
};

export default useNavHighlight;
